import React from "react";
import { Box, Typography, Stack, Chip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

interface PackageCardProps {
  name: string;
  isRecommended: boolean;
  price: number;
  subtitle: string;
  features: string[];
}

const PackageCard: React.FC<PackageCardProps> = ({
  name,
  isRecommended,
  price,
  subtitle,
  features,
}) => {
  return (
    <Box
      sx={{
        border: isRecommended ? "2px solid #614338" : "1px solid #e0e0e0",
        borderRadius: 2,
        p: 3,
        bgcolor: isRecommended ? "#e5d3ccff" : "transparent",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6" fontWeight="bold">
            {name}
          </Typography>
          {isRecommended && (
            <Chip
              label="★ Recommended"
              size="small"
              sx={{ bgcolor: "#1976d2", color: "white", fontWeight: "bold" }}
            />
          )}
        </Stack>
        <Typography variant="h6" fontWeight="bold" color="primary">
          ${price.toFixed(2)}
        </Typography>
      </Stack>

      <Typography variant="body2" color="text.secondary" gutterBottom>
        {subtitle}
      </Typography>

      <Typography variant="body2" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>
        Package Includes:
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 1,
        }}
      >
        {features.map((feature, index) => (
          <Stack key={index} direction="row" spacing={1} alignItems="center">
            <CheckIcon sx={{ fontSize: 16, color: "success.main" }} />
            <Typography variant="body2">{feature}</Typography>
          </Stack>
        ))}
      </Box>
    </Box>
  );
};

export default PackageCard;
